// Minimal GA helper for GA4 (gtag.js)
// Assumes the tag is loaded in public/index.html

const GA_MEASUREMENT_ID = 'G-8HMJVZHRK8';

export function trackPageview(path) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
}

export function trackEvent(action, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
}
